<div class="proximity-map-page">
  <section class="search-panel">
    <div class="search-controls">
      <input [(ngModel)]="searchQuery" type="text" placeholder="Wyszukaj sklepy/punkty usługowe" />
      <button (click)="searchPlaces()" class="primary">Szukaj</button>
      <button (click)="map?.setView([52.2297,21.0122], 14)">Reset</button>
    </div>
    <div class="search-results" *ngIf="searchResults.length > 0">
      <h3>Wyniki wyszukiwania</h3>
      <ul>
        @for(item of searchResults; track item.id) {
        <li (click)="selectPlace(item)" (keypress.enter)="selectPlace(item)" tabindex="0"
          [class.active]="selectedPlace?.id===item.id">
          <strong>{{item.name}}</strong><br />
          <small>{{item.address}}</small>
        </li>
        }

      </ul>
    </div>
  </section>

  <section class="main-content">
    <div class="map-column">
      <div #mapContainer class="map-box"></div>
      <div class="custom-place-panel">
        <h3>Dodaj własny punkt</h3>
        <input [(ngModel)]="newCustomName" type="text" placeholder="Nazwa miejsca" />
        <input [(ngModel)]="newCustomAddress" type="text" placeholder="Adres (opcjonalny)" />
        <span>Wskaż lokalizację: kliknij na mapie lub dodaj w miejscu widoku</span>
        <button (click)="addCustomPlace()">Dodaj punkt</button>
      </div>
    </div>

    <aside class="sidebar-column">
      <div class="selected-place-box" *ngIf="selectedPlace">
        <h3>{{ selectedPlace.name }}</h3>
        <p>{{ selectedPlace.address }}</p>
        <small>Typ: {{ selectedPlace.source === 'custom' ? 'Własny' : 'Z wyszukiwarki' }}</small>
      </div>

      <div class="task-form" *ngIf="selectedPlace">
        <h3>Dodaj zadanie</h3>
        <textarea [(ngModel)]="newTaskNote" rows="2" placeholder="Notatka"></textarea>
        <input [(ngModel)]="newTaskDueDate" type="date" />
        <select [(ngModel)]="newTaskStatus">
          <option *ngFor="let status of statuses" [value]="status">{{ status }}</option>
        </select>
        <button (click)="createTaskForSelectedPlace()">Zapisz zadanie</button>
      </div>

      <div class="tasks-box">
        <div class="header-row">
          <h3>Zadania</h3>
          <label>
            <input type="checkbox" [(ngModel)]="modeShowTasksOnMap" (change)="onToggleTaskPins()" /> Pokaż jako pinezki
          </label>
        </div>

        <p class="info">Wybierz obiekt, by przypisać zadanie.</p>

        <ul>
          <li *ngFor="let task of tasks" [class.selected]="task.placeId===selectedPlace?.id">
            <strong>{{ findPlaceById(task.placeId)?.name || 'Nieznany punkt' }}</strong>
            <p>{{ task.note }}</p>
            <small>
              {{ task.dueDate ? ('Termin: ' + task.dueDate + ' | ') : '' }}
              Status: {{ task.status }}
            </small>
            <button class="small" (click)="removeTask(task.id)">Usuń</button>
          </li>
        </ul>
      </div>
    </aside>
  </section>
</div>